module.exports = __webpack_public_path__ + "img/background.32476828.png";